<template>

	<!-- 弹出向导层 start-->
	<div id="pop" class="pop" v-show="pop_show">
		<span class="pop_bg"></span>

		<div id="pop_bodyup" class="pop_content">
			<!-- 动态查询区生成 -->
			<div class="pop_head_close">
				<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
			</div>
			<div class="row-title" id="pop_tan_notice">
				<div class="row-note title">
					<div class="row-item">
						操作说明:1、选择对应收款明细直接录入收款日期、收款金额、收款方式、收款备注。默认冲抵顺序利息=>本金=>滞纳金
					</div>
					<div class="row-item">
						正常收款:在最后还款日期前,每次实际收款本金小于等于应收本金与应收利息之和,则完成一条,则自动计算生成剩余部分!
					</div>
					<div class="row-item red">
						提前收款:实际收款本金大于应收本金与应收利息之和,则完成后,会自动冲抵下一期的利息与本金,直到冲抵完成!
					</div>
					<div class="row-item red">
						免除申请:实际收款不足以支付利息+本金+滞纳金,协商完成后,发起申请,需要经理二次审核!
					</div>
					<div class="row-item red">
						延期收款:因特殊原因,从当前明细的收款日期开始整体往后推一段时间,但是又不算逾期,需要经理二次审核才生效!
					</div>
					<div class="row-item red">
						特殊情景:必须主动修改收款状态为指定项,然后再发起申请,方能生效!
					</div>
				</div>
			</div>
			<div class="content_edit row-line">
				<div class="content_edit_item">关联单号:{{sheet_no}}</div>
				<div class="content_edit_item">
					<button class="pre_btn_ok" @click="build_sheet('_add')">
						更新收款明细
					</button>&nbsp;
					<button @click="look_note">使用说明</button>
				</div>
			</div>

			<div class="row-body" v-loading="element_loading" element-loading-text="拼命加载中......"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="row-mid">

					<div class="inline-row">
						<div class="content_edit_item">
							<h5>待收款明细汇总</h5>
							<button class="pre_btn_ok" @click="load_pay_d()">
								刷新
							</button>
						</div>
					</div>
					<div class="inline-row check-list">

						<div class="content_edit_item" v-show="detail_sel_show">
							<span>约定应还:</span>
							<span class="row-label">本金=</span><span
								class="row-warning">{{detail_sel_item.pay_amount}}</span>
							<span class="row-label">利息=</span><span
								class="row-warning">{{detail_sel_item.pay_rate}}</span>
							<span class="row-label">滞纳金=</span><span
								class="row-warning">{{detail_sel_item.over_fee}}</span>
						</div>
						<div class="content_edit_item" v-show="detail_sel_show">
							<span>实际收款:</span>
							<span class="row-label">本金=</span><span
								class="row-warning red">{{detail_sel_item.amount_ok}}</span>
							<span class="row-label">利息=</span><span
								class="row-warning red">{{detail_sel_item.amount_rate}}</span>
							<span class="row-label">滞纳金=</span><span
								class="row-warning red">{{detail_sel_item.amount_out}}</span>
						</div>
						<div class="content_edit_item" v-show="detail_sel_show">
							<span>差异金额:</span>
							<span class="row-warning row-warning-end ">{{detail_sel_item.amount_last}}</span>
						</div>
					</div>
					<div class="inline-row mark-detail">
						<table class="dataintable ">
							<tr class="tab_header">
								<td>序号</td>
								<td>应付日期</td>
								<td>原付日期</td>
								<td>应付本金</td>
								<td>实付利息</td>
								<td>产生滞纳金</td>
								<td>逾期天数</td>
								<td>应付总额</td>
								<td>实付总额</td>
								<td>状态</td>
							</tr>
							<tr :id="'pop_d_'+item.row_num" v-for="(item,index) in list_pay_d" :key="index"
								@click="sel_row_d(item)">
								<td>{{item.row_num}}</td>
								<td>{{item.pay_date}}</td>
								<td>{{item.pay_date_bak}}</td>
								<td>{{item.pay_amount}}</td>
								<td>{{item.pay_rate}}</td>
								<td>{{item.over_fee}}</td>
								<td>{{item.over_days}}</td>
								<td>{{item.pay_all}}</td>
								<td>{{item.amount_all}}</td>
								<td>{{item.is_paper}}</td>
							</tr>
						</table>
					</div>

				</div>
				<div class="row-mid">
					<div class="inline-row">
						<div class="content_edit_item">
							<button class="pre_btn_ok" @click="load_pay_c()">
								刷新
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_add')">
								保存
							</button>
							<!-- <button class="pre_btn_ok" @click="fun_upd('_del')">
								删除
							</button> -->
							<button class="pre_btn_ok" @click="fun_upd('_sub')">
								提交
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_bad')">
								作废
							</button>
							<button class="pre_btn_ok" @click="excelup()">
								导入
							</button>
							<button class="pre_btn_ok" @click="build_exceldata()">
								导出
							</button>

							<label>{{sheet_flag}}&nbsp;&nbsp;{{is_over}}&nbsp;&nbsp;</label>
						</div>
					</div>
					<div class="inline-row">
						<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
							<div class="content_edit_item tab-row" v-if="item.x == r.row" v-for="(item,index) in parm"
								:key="index">

								<component :is="NextTickName(item.type)" :inData="checkJson(item)"
									@com-event="refresh_view_all">
								</component>
							</div>
						</div>
					</div>
					<div class="inline-row mark-detail">
						<table class="dataintable ">
							<tr class="tab_header">
								<td>序号</td>
								<td>收款日期</td>
								<td>收款金额</td>
								<td>支付利息</td>
								<td>支付本金</td>
								<td>支付滞纳金</td>
								<td>逾期天数</td>
								<td>收款方式</td>
								<td>使用月保证金</td>
								<td>收款状态</td>
								<td>新增滞纳金</td>
								<td>剩余待付合计</td>
								<td>剩余利息</td>
								<td>剩余本金</td>
								<td>剩余滞纳金</td>
								<td>备注</td>
								<td>状态</td>
								<td>录入人</td>
								<td>更新日期</td>
								<!-- <td class="short0 cen">编辑</td> -->
							</tr>
							<tr :id="'pop_c_'+item.row_num" v-for="(item,index) in list_pay_c" :key="index"
								@click="sel_row_c(item,'_sel')">
								<td>{{item.row_num}}</td>
								<td>{{item.pay_date}}</td>
								<td>{{item.amount}}</td>
								<td>{{item.amount_rate}}</td>
								<td>{{item.amount_ok}}</td>
								<td>{{item.amount_fee}}</td>
								<td>{{item.over_days}}</td>
								<td>{{item.pay_way}}</td>

								<td>{{item.amount_month}}</td>
								<td>{{item.is_over}}</td>
								<td>{{item.over_fee}}</td>

								<td>{{item.pay_last}}</td>
								<td>{{item.last_rate}}</td>
								<td>{{item.last_ok}}</td>
								<td>{{item.last_fee}}</td>
								<td>{{backStr(item.note)}}</td>
								<td>{{item.flag}}</td>
								<td>{{item.u_name}}</td>
								<td>{{item.sys_date}}</td>
								<!-- <td class="short0 cen">
									<button @click="sel_row_c(item,'_edit')">编辑</button>
								</td> -->
							</tr>
						</table>
					</div>

				</div>


			</div>
		</div>

		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in d_name" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr @click="sel_row(user.item)">
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="fun_d_load" :pre_th="d_parm" :api_url="d_sel_action"
			:api_action="d_upd_action" :api_method="'exp15'" :api_check="''" />




		<!-- 弹出向导层 end-->

	</div>
</template>

<script>
	/*
名称：综合入库、转移、销毁
日期：2023-03-24
作者：hj
目标：
方法 传入参数，
1、查询标识
2、编辑标识
*/

	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common
	} from '@/utils/loadhttpdata.js';

	import {
		BackSpecial
	} from "@/utils/localstore.js";

	export default {
		name: "pre_editstore_tan",
		components: {
			"pre-table": () => import("../auto/auto_view_table.vue"),
			'per-exceldown': () => import("../auto/auto_excel_down.vue"),
			'per-excelup': () => import("../auto/auto_excel_up.vue")

		},
		data() {
			return {
				element_loading: false,
				pop_show: false,
				show_btn: true,
				load_url: '',
				load_json: '',
				upd_json: '',
				screenWidth: '',
				screenHeight: '',

				title: '未设置标题',
				show_note: false,
				sheet_no: '',
				sheet_flag: '',
				sel_action: '',
				upd_action: '',
				row_id: '',
				sel_item: [], //备份点击项目
				sys_date: '',

				max_row: [],
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',

				// post_select: ''
				show_detail: false,
				d_sel_action: '',
				d_upd_action: '',

				d_parm: [], //参数结构
				d_name: [], //明细标题
				d_detail: [], //明细数据
				d_row_id: '',
				d_sys_date: '',
				list_detail: [],

				list_pay_d: [],
				detail_sel_item: {},
				detail_sel_id: '', //选择的明细
				detail_sel_show: false,

				list_pay_c: [], //支付列表

				is_over: '',
				check_key: '',
				//下明是 具体参数/////////

				// excel
				show_excel: false,
				postjson1: {},


			};
		},
		methods: {
			backStr: function(s) {
				return BackSpecial(s);
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#pop_tan_notice").slideDown("slow");
				} else {
					$("#pop_tan_notice").slideUp("slow");
				}
			},
			showpop: function(parm) {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_bg").fadeIn("3000");
				$(".pop_content").fadeIn("3000");
				this.load_data(parm)
			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			NextTickName: function(key) {
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_all: function(d, type) {
				// console.log('编辑方式',d);
				for (let i = 0; i < this.parm.length; i++) {

					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;
						} else {
							this.parm[i].val = d.val;
						}
						break;
					}
				}

				if (type == 'save') {
					this.fun_upd('_add');
				}

			},
			load_data: function(res) {
				console.log('传入解析', res);
				$("#pop_tan_notice").slideUp("slow"); //关闭使用说明

				this.max_row = [];
				for (let i = 1; i <= 4; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				this.title = res.title;
				this.sheet_no = res.sheet_no;

				this.parm = [{
						"name": "收款日期",
						"val": "",
						"key": "pay_date",
						"type": "date",
						"class": "long1",
						"note": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款金额",
						"val": "",
						"key": "amount",
						"type": "number",
						"class": "long1",
						"note": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款方式",
						"val": "",
						"key": "pay_way",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "使用月保证金",
						"val": "",
						"key": "amount_month",
						"type": "number",
						"class": "long1",
						"note": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款状态",
						"val": "",
						"key": "is_over",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_sellpay_class",
						"sel_name": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long3",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					}
				]

				// 检查 是否存在需要支付的明细 
				this.build_sheet();

			},
			build_sheet: function() {
				this.detail_sel_id = '';
				let d = [];
				d.push(this.sheet_no);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('_cw_build_pay_detail', 0, '', d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log('建立结果', res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.load_pay_d();
						this.load_pay_c();


					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

				// 再次加载已经生成的单据 
			},
			load_pay_d: function() {
				// console.log('加载已经比较列表')
				this.element_loading = true;
				this.detail_sel_show = false;
				let r = (Math.random() + '').substring(0, 8);
				this.list_pay_d = [];
				this.$post(
					api.http_method, Sel_page_and_length('exp_cw_paysheet_d', 1, 100, this.sheet_no, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					let arr = [];
					for (let i = 0; i < res[0].length; i++) {
						// let o = {};
						// o.key = 'pay_amount_all';
						// o.val = res[0][i].pay_amount + res[0][i].pay_rate + res[0][i].over_fee;
						let pay_amount_all = 0,
							amount_last = 0;
						pay_amount_all = res[0][i].pay_amount + res[0][i].pay_rate + res[0][i].over_fee;
						pay_amount_all = Number(pay_amount_all).toFixed(2);

						amount_last = pay_amount_all - res[0][i].amount_all;
						amount_last = Number(amount_last).toFixed(2);

						res[0][i].pay_amount_all = pay_amount_all; //应还总额
						res[0][i].amount_last = amount_last; //剩余金额
						// console.log(res[0][i]);
						arr.push(res[0][i]);
					}
					this.list_pay_d = arr;
					this.init_up_excel();
				});
			},
			load_pay_c: function() {
				// console.log('加载支付列表')
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				this.list_pay_c = [];
				this.$post(
					api.http_method, Sel_page_and_length('exp_cw_pay_d_list_c', 1, 100, this.sheet_no, this
						.detail_sel_id, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0) {
						this.list_pay_c = res[0];
					} else {
						this.$message({
							message: '前置收款明细未完成,不能开始当前条目!',
							type: 'warning'
						});
					}

				});

				// 再次加载已经生成的单据 
			},
			init_up_excel: function() {
				// 初始化上传参数模板
				this.d_parm = [];
				this.d_parm = [{
						"name": "业务单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1",
						"note": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款关联ID",
						"val": "",
						"key": "d_id",
						"type": "number",
						"class": "long1",
						"note": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款日期",
						"val": "",
						"key": "pay_date",
						"type": "date",
						"class": "long1",
						"note": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款金额",
						"val": "",
						"key": "amount",
						"type": "number",
						"class": "long1",
						"note": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "收款方式",
						"val": "",
						"key": "pay_way",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "使用月保证金",
						"val": "",
						"key": "amount_month",
						"type": "number",
						"class": "long1",
						"note": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long3",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					}
				]
			},
			sel_row_d: function(item, type) {
				console.log('待核对', item);
				this.detail_sel_id = item.id;
				this.detail_sel_item = item;
				this.detail_sel_show = true;
				let key = 'pop_d_';

				for (var i = 0; i < this.list_pay_d.length; i++) {
					if (this.list_pay_d[i].row_num == item.row_num) {
						document.getElementById(key + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_pay_d[i].row_num % 2 == 0) {
							document.getElementById(key + this.list_pay_d[i].row_num).style.background =
								'#fff';
						} else {
							document.getElementById(key + this.list_pay_d[i].row_num).style.background =
								'#f5f5f5';
						}
					}
				}
				this.load_pay_c();

			},
			sel_row_c: function(item) {
				console.log('业务数据=', item);

				this.sheet_flag = '';
				this.is_over = '';
				this.row_id = 0;
				this.sys_date = '';

				this.sheet_flag = item.flag;
				this.is_over = item.is_over;
				this.row_id = item.id;
				this.sys_date = item.sys_date;

				for (let d in item) {
					// console.log(d+'='+item[d])					
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == d) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
								// //console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[d];
							} else {
								this.parm[j].val = item[d];
							}

						}
					}
				}

			},
			fun_upd: function(type) {
				// console.log('操作类型=' + type);
				// console.log('row_id=' + this.row_id + ' sys_date=' + this.sys_date);
				if (type != '_add') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要编辑的数据!',
							type: 'warning'
						});
						return;
					}
				}



				let d = [];
				d.push(this.sheet_no);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].p == '1') {
						d.push(this.parm[i].val);
					}
				}

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('_cw_paysheet_c' + type, this.row_id, this.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.row_id = res.data.parm.id;
						this.sys_date = res.data.parm.sys_date;
						this.sheet_flag = res.data.parm.flag;
						// 加载列表
						this.load_pay_d();
						// 刷新自己
						this.load_pay_c();


					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			///////////////////////
			excelup: function() {
				console.log('上传。。。');
				if (this.sheet_no == '') {
					this.$message({
						message: ' 主单号不能为空,请先选择盘点仓库并且保存!',
						type: 'warning'
					});
					return
				}

				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			build_exceldata: function(type) {
				if (type == 'close') {
					this.show_excel = false;
				} else {

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Sel_page_and_length(this.d_sel_action, 1, 999, this.sheet_no)
					});

					this.show_excel = true;
				}
			},
			fun_d_load: function() {

				this.d_detail = [];

				this.element_loading = true;
				this.$post(
					api.http_method,
					Sel_page_and_length(this.d_sel_action, 1, 999, this.sheet_no)
				).then(res => {
					this.element_loading = false;

					res = JSON.parse(res);
					// console.log('明细返回', res);
					if (res.length > 0) {
						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.d_detail.push(t[i]);
						}
						// console.log(this.d_detail);

						let that = this;
						setTimeout(() => {
							that.fun_chage();
						}, 200)

					} else {
						this.$message({
							message: "没有查询到明细",
							type: 'success'
						});
					}
				});
			},
			fun_chage: function() {
				// 样式设定
				for (let i = 0; i < this.d_detail.length; i++) {
					// console.log(this.d_detail[i]);
					let temp_id = 'd_' + this.d_detail[i].row_num;
					let qty = this.d_detail[i].qty;
					let temp_css = '';
					if (Number(qty) < 0) {
						temp_css = 'background-color: #f7e3a8 !important;';
						document.getElementById(temp_id).style.cssText = temp_css;
					}

					if (Number(qty) > 0) {
						temp_css = 'background-color: #f2c7b2 !important;';
						document.getElementById(temp_id).style.cssText = temp_css;
					}

				}
			},

		}
	};
</script>


<style scoped>
	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}

	.pop_bg {
		z-index: 998;
	}

	.pop_content {
		position: fixed;
		width: 98%;
		height: auto;
		left: 1%;
		top: 8%;
		/* background: #faf5f5; */
		/* background-color: azure; */
		background: rgb(195, 219, 250);
		border-radius: 5px;
		max-height: 80%;
		z-index: 999;
		overflow-y: auto;
		overflow-x: hidden;

		box-shadow: 0 0 5px 5px #0872a7;
	}

	.row-title {
		display: flex;
		align-items: flex-start;
	}

	.row-note {
		display: flex;
		flex-direction: column;
	}

	.row-note .row-item {
		display: flex;
		line-height: 24px;
		font-size: 14px;
		font-weight: bold;
		/* color: #ff0000 */
	}

	.row-line {
		display: flex;
		align-items: center;
	}


	.row-body {
		display: flex;
	}


	.row-mid {
		display: inline-flex;
		flex-direction: column;
		align-content: flex-start;
		align-items: flex-start;
		background-color: #b1cad7;
		border-radius: 5px;
		margin: 2px;

	}

	.mark-detail {
		display: inline-flex;
		flex-direction: column;
		margin-top: 8px;
	}

	.mark-detail-top label {
		display: inline-flex;
		vertical-align: middle;
		margin-right: 6px;
		min-width: 36px;
		line-height: 24px;
	}

	.mark-detail-top span {
		display: inline-flex;
		vertical-align: middle;
		margin-right: 2px;

		color: #ff0000;
		line-height: 24px;
	}

	.mark-detail-top input {
		display: inline-flex;
		vertical-align: middle;
		width: 64px;
		line-height: 24px;
	}

	.check-list {
		display: flex;
		flex-direction: column;
		height: 80px;
		justify-content: center;
	}

	.check-list span,
	.row-warning {
		display: inline-flex;
		font-size: 16px;
		color: black;
		height: 28px;
		line-height: 28px;
	}

	.row-label {
		margin-left: 8px;
		min-width: 48px;
		text-align: right;
		display: inline-flex;
		justify-content: flex-end;
	}

	.row-warning {
		font-weight: bolder;
		min-width: 80px;
	}

	.row-warning-end {
		color: #ff0000 !important;
		font-size: 18px !important;
		margin-left: 8px;
		font-weight: bolder;
	}
</style>